//React imports
import React, { useEffect } from "react";

import FooterComponent from "../../components/home/FooterComponent.js";

//Imports assets such as images
import NavBarComponent from "../../components/navBar/NavBarComponent.js";
import CartAbandonmentComponent from "../../components/solutions/cashbackInfo/cartAbandonment.jsx";

export default function CartAbandonmentPage() {
    return (
        <div>
            <NavBarComponent />
            <CartAbandonmentComponent />
            <FooterComponent />
        </div>
    );
}
